import { Routes } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { LanguageService } from './services/language.service';

/**
 * Manuel utilisateur public, porté tel quel depuis le projet Youthconnekt-manual
 * (voir src/app/features/manual/README pour le détail). Ses pages utilisent leurs
 * propres clés de traduction (public/manual-i18n/{fr,en}.json) : on leur fournit ici
 * un TranslateService et un LanguageService dédiés, scopés à ce sous-arbre de routes,
 * pour ne jamais interférer avec le catalogue i18n du reste du site.
 */
export const MANUAL_ROUTES: Routes = [
  {
    path: '',
    providers: [
      provideTranslateService({
        lang: 'fr',
        fallbackLang: 'fr',
        loader: provideTranslateHttpLoader({ prefix: '/manual-i18n/', suffix: '.json' }),
      }),
      LanguageService,
    ],
    loadComponent: () =>
      import('./manual-layout/manual-layout').then((m) => m.ManualLayout),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
        title: 'Manuel Youth Connekt Cameroon',
      },
      {
        path: 'introduction',
        loadComponent: () =>
          import('./pages/introduction/introduction.component').then((m) => m.IntroductionComponent),
        title: 'Introduction — Manuel Youth Connekt',
      },
      {
        path: 'getting-started',
        loadComponent: () =>
          import('./pages/getting-started/getting-started.component').then(
            (m) => m.GettingStartedComponent,
          ),
        title: 'Démarrage rapide — Manuel Youth Connekt',
      },
      {
        path: 'discover',
        loadComponent: () =>
          import('./pages/discover/discover.component').then((m) => m.DiscoverComponent),
        title: 'Découvrir sans compte — Manuel Youth Connekt',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        title: 'Mon tableau de bord — Manuel Youth Connekt',
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/profile/profile.component').then((m) => m.ProfileComponent),
        title: 'Mon profil — Manuel Youth Connekt',
      },
      {
        path: 'security',
        loadComponent: () =>
          import('./pages/security/security.component').then((m) => m.SecurityComponent),
        title: 'Sécurité du compte — Manuel Youth Connekt',
      },
      {
        path: 'applications',
        loadComponent: () =>
          import('./pages/applications/applications.component').then(
            (m) => m.ApplicationsComponent,
          ),
        title: 'Mes candidatures — Manuel Youth Connekt',
      },
      {
        path: 'trainings',
        loadComponent: () =>
          import('./pages/trainings/trainings.component').then((m) => m.TrainingsComponent),
        title: 'Formations — Manuel Youth Connekt',
      },
      {
        path: 'favorites',
        loadComponent: () =>
          import('./pages/favorites/favorites.component').then((m) => m.FavoritesComponent),
        title: 'Favoris — Manuel Youth Connekt',
      },
      {
        path: 'network',
        loadComponent: () =>
          import('./pages/network/network.component').then((m) => m.NetworkComponent),
        title: 'Réseau — Manuel Youth Connekt',
      },
      {
        path: 'glossary',
        loadComponent: () =>
          import('./pages/glossary/glossary.component').then((m) => m.GlossaryComponent),
        title: 'Glossaire — Manuel Youth Connekt',
      },
      {
        path: 'support',
        loadComponent: () =>
          import('./pages/support/support.component').then((m) => m.SupportComponent),
        title: 'FAQ & Support — Manuel Youth Connekt',
      },
    ],
  },
];
